/*eslint "react/no-set-state": 0*/
import {ImmutableStore} from 'fluxible-immutable-utils';
import Actions from '../constants/Actions';

class ManageAccountStore extends ImmutableStore {
  static storeName = 'ManageAccountStore';

  static handlers = {
    [Actions.ACCOUNT_EDIT_BEGIN]: 'setDefaultState',
    [Actions.ACCOUNT_EDIT_END]: 'setDefaultState',
    [Actions.PASSWORD_FORGOT_COMPLETE]: 'passwordResetStarted',
    [Actions.ACCOUNT_CLEAR_MESSAGES]: 'clearMessages'
  };

  constructor(dispatcher) {
    super(dispatcher);
    this.setState({
      user: {},
      saved: false,
      passwordResetSent: false
    });
  }

  setDefaultState({ saved = false, passwordResetSent = false } = {}) {
    const state = {
      saved: saved,
      passwordResetSent: passwordResetSent
    };
    this.setState(state);
  }

  getUser() {
    return this.get('user').toJS();
  }

  saved() {
    return this.get('saved') || false;
  }

  passwordResetStarted() {
    console.log('Password reset event captured.  Setting passwordResetSent to true');
    this.mergeState({
      passwordResetSent: true
    });
  }

  passwordResetSent() {
    return this.get('passwordResetSent') || false;
  }

  clearMessages() {
    this.mergeState({
      passwordResetSent: false,
      saved: false
    });
  }

}

export default ManageAccountStore;



// WEBPACK FOOTER //
// ./src/stores/ManageAccountStore.js